import React from "react";
import TableCell from "@mui/material/TableCell";
import { IconButton, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import SaveIcon from "@mui/icons-material/Save";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import PreviewIcon from "@mui/icons-material/Preview";
import SendIcon from "@mui/icons-material/Send";

export default function Actions({
  editIndex,
  index,
  validate,
  row,
  options,
  setSaved,
  rowCopy,
}) {
  return (
    <TableCell
      sx={(theme) => ({
        minWidth: "170px",
        width: "100%",
        backgroundColor: "white",
        [theme.breakpoints.up("md")]: {
          position: "sticky",
          right: 0,
        },
        padding: "0px 16px",
        borderLeft: "dotted 1px gray !important",
      })}
      component="th"
      scope="row"
    >
      {editIndex.rowIndex === index && options?.save && (
        <Tooltip title="Save">
          <IconButton
            id="button"
            onClick={(e) => {
              e.stopPropagation();

              validate(row);
            }}
          >
            <SaveIcon />
          </IconButton>
        </Tooltip>
      )}

      {options?.delete && (
        <Tooltip title="Delete">
          <IconButton
            id="button"
            onClick={(e) => {
              e.stopPropagation();

              setSaved(true);

              options.delete(row);
            }}
          >
            <DeleteIcon sx={{ color: "error.light" }} />
          </IconButton>
        </Tooltip>
      )}

      {options?.open && (
        <Tooltip title="Open">
          <IconButton
            onClick={(e) => {
              e.stopPropagation();

              setSaved(true);

              options.delete(row);
            }}
          >
            <OpenInNewIcon sx={{ color: "primary.light" }} />
          </IconButton>
        </Tooltip>
      )}
      {!options?.edit ? null : (
        <Tooltip title="Edit">
          <IconButton
            onClick={(e) => {
              e.stopPropagation();

              setSaved(true);

              options.delete(row);
            }}
          >
            <EditIcon sx={{ color: "primary.light" }} />
          </IconButton>
        </Tooltip>
      )}
      {!options?.check ? null : (
        <Tooltip title="Delete">
          <IconButton
            onClick={(e) => {
              e.stopPropagation();

              setSaved(true);

              options.delete(row);
            }}
          >
            <CheckIcon sx={{ color: "primary.light" }} />
          </IconButton>
        </Tooltip>
      )}
      {!options?.uncheck ? null : (
        <Tooltip title="Delete">
          <IconButton
            onClick={(e) => {
              e.stopPropagation();

              setSaved(true);

              options.delete(row);
            }}
          >
            <CloseIcon sx={{ color: "primary.light" }} />
          </IconButton>
        </Tooltip>
      )}
      {options?.open ? (
        <Tooltip title="Open">
          <IconButton
            onClick={(e) => {
              e.stopPropagation();

              setSaved(true);

              options.delete(row);
            }}
          >
            <OpenInNewIcon sx={{ color: "primary.light" }} />
          </IconButton>
        </Tooltip>
      ) : null}
      {options?.send ? (
        <Tooltip title="Send">
          <IconButton
            onClick={(e) => {
              e.stopPropagation();

              setSaved(true);

              options.delete(row);
            }}
          >
            <SendIcon sx={{ color: "primary.light" }} />
          </IconButton>
        </Tooltip>
      ) : null}
      {options?.preview ? (
        <Tooltip title="Preview">
          <IconButton
            onClick={(e) => {
              e.stopPropagation();

              setSaved(true);

              options.delete(row);
            }}
          >
            <PreviewIcon sx={{ color: "primary.light" }} />
          </IconButton>
        </Tooltip>
      ) : null}
      {options?.print ? (
        <Tooltip title="Print">
          <IconButton
            onClick={(e) => {
              e.stopPropagation();

              setSaved(true);

              options.delete(row);
            }}
          >
            <PreviewIcon sx={{ color: "primary.light" }} />
          </IconButton>
        </Tooltip>
      ) : null}
    </TableCell>
  );
}
